export default __webpack_public_path__ + "static/media/zonlogo.e7dcb032.webp";